module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPUlEQVQYlYXKSQoAIAwEwTb47oDiO3yrJ8Ely5x6oIqOqUAnmAAN0AyRQTnahfJ8E77IhBb6oIcuWAO0IQv9iwouEZd5DQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/pumpMonitor/leftOne/zidong.png
// module id = fsM7
// module chunks = 163